<template>
  <div class="pager404 full-height full-width text-center">
    <q-img src="~assets/images/error/error404.png" :ratio="16 / 10" />
    <div class="font-size-24 q-mt-xl text-weight-bold text-black">
      <div>Sorry,</div>
      <div>the page no longer exists</div>
    </div>
    <!-- <div class="q-mt-xl">
      <q-btn
        no-caps
        unelevated
        class="text-weight-bolder border-radius-8"
        label="Visit Menu"
        color="primary"
        :to="`/${storeUrl}`"
      />
    </div> -->
<!--    <div class="q-mt-sm">-->
<!--      <q-btn-->
<!--        no-caps-->
<!--        unelevated-->
<!--        class="text-weight-bolder border-radius-8"-->
<!--        color="primary"-->
<!--      >-->
<!--        <a href="https://business.horego.com/#hero">Visit HomePage</a>-->
<!--      </q-btn>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: 'Error404',
  created() {},
  mounted() {
    // window.location.href = 'https://business.horego.com/#hero';
  },
};
</script>

<style lang="scss" scoped>
.pager404 {
  background-color: #f3f4f6;
}
</style>
